import "./contacts.scss"
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { useState } from "react";
import emailjs from "emailjs-com";




export default function Contacts({theme, setTheme}) {

  

  

 const [message, setMessage] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(true);
    emailjs.sendForm("service_6ti0eqm","template_s3bp2gl",e.target,"4zFZ5TcmcLgyvP4q_");

    
  };

  const [formData, setFormData] = useState({
    
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.values
    });
  };



  return (
    <div className={"contacts "+ (theme && "dark")} id="contacts">
    <div className="left">
      <ContactMailIcon className="contactIcon"/>
    </div>
    <div className="right">
          <h2>Contact.</h2>
          <form onSubmit={handleSubmit} 
          action="https://formspree.io/f/myyanjlj"
          method="POST"> 
          <input type="email" 
                 name="email" 
                 placeholder="Email" 
                 value={formData.email}
                 onChange={handleChange}
                 required
                 />
          <textarea name="message" 
                    placeholder="Message" 
                    value={formData.message}
                    onChange={handleChange}
                    required ></textarea>
          <button type="submit">SEND</button>
          {message &&  <span>Thanks, I'll response ASAP!!</span>}
          </form>
    </div>
    </div>
    
  );
}

